/* BarkBurst – Warenkorb: zeigt das generierte Bild statt des Produkt-Mockups */
(function () {
  function row(el) {
    var n = el;
    while (n && n !== document.body) {
      if (n.querySelector && n.querySelector('.cart-items__media-image')) return n;
      n = n.parentElement;
    }
    return null;
  }
  function run() {
    document.querySelectorAll('.cart-items__property:not([data-bbc])').forEach(function (p) {
      var dt = p.querySelector('dt'), dd = p.querySelector('dd');
      if (!dt || !dd) return;
      var l = dt.textContent.trim().replace(/:$/, '').toLowerCase();
      if (l !== 'stil-version' && l !== 'stil') return;
      p.setAttribute('data-bbc', '1');
      if (l === 'stil-version') {
        var a = dd.querySelector('a');
        var r = row(p);
        var im = r && r.querySelector('.cart-items__media-image');
        if (a && a.href && im) {
          im.removeAttribute('srcset');
          im.removeAttribute('sizes');
          im.src = a.href;
          im.alt = 'Dein generiertes Portrait';
          im.classList.add('bb-cart-gen');
        }
      }
      p.classList.add('bb-prop-hide');
    });
  }
  var q = false;
  function sch() { if (q) return; q = true; requestAnimationFrame(function () { q = false; run(); }); }
  function start() { run(); new MutationObserver(sch).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
